angular.module('rjmNg.directives').directive 'freeTrialBilling', () ->
  restrict: 'E'
  templateUrl:  "directive.freeTrialBilling.html"
  replace: true
  controllerAs: 'view'
  controller: [
    "$rootScope"
    "$scope"
    "app"
    "appRoute"
    "Billing"
    "dashboardService"
    (
      $rootScope
      $scope
      app
      appRoute
      Billing
      dashboardService
    ) ->
      view = @

      _hideFreeTrialBillingModalListener = null

      view.billingUrl = appRoute("/settings/billing/")
      view.daysRemaining = -1
      view.allowModalDismiss = true

      view.feedback = ->
        Intercom("showNewMessage", "Adobe Commerce Intelligence Essentials Feedback:")
      view.upgradeToPro = ->
        Intercom("showNewMessage", "I'm interested in learning more about Adobe Commerce Intelligence Pro!")
      view.cancelSubscription = ->
        Intercom("showNewMessage", "I'd like to cancel my subscription, pease.")
      view.hideModal = () ->
        dashboardService.unlockNavBar()

      view.$postLink = () ->
        dashboardService.lockNavBar()

        Billing.getStatus(app.getClientId())
        .then (status) ->
          view.daysRemaining = status?.free_trial?.days_remaining
          view.allowModalDismiss = view.daysRemaining != 0
        .catch () ->

        _hideFreeTrialBillingModalListener = $rootScope.$on("hideFreeTrialBillingModal", () ->
          view.hideModal()
          $scope.hide()
        )

      view.$onDestroy = () ->
        _hideFreeTrialBillingModalListener()
        return

      view
  ]
